declare const VERSION: string;
declare const ENV: string;
// eslint-disable-next-line no-undef
export const version = VERSION;
export { TranslationProject, OwcTranslationManagerState } from './connections/types';
export * from './connections';
